import MinesweeperBoard from "./minesweeper/MinesweeperBoard";
function App() {
  return <MinesweeperBoard />;
}

export default App;
